module.exports = __webpack_public_path__ + "static/media/print7.72b2b33c.jpg";